import { render } from "./cardMember.vue?vue&type=template&id=30c1163c&scoped=true"
import script from "./cardMember.vue?vue&type=script&lang=js"
export * from "./cardMember.vue?vue&type=script&lang=js"

import "./cardMember.vue?vue&type=style&index=0&id=30c1163c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c1163c"]])

export default __exports__